/**
 * Header title of the visible article route. The title is tagged with the
 * route key of the article view that reported it, so a late "clear" from an
 * exiting article (its unmount is delayed by the exit animation) cannot wipe
 * the title the next article already set, and one article's title is never
 * shown for another route.
 */
export type ArticleTitleState = { key: string; title: string } | null;

export function reduceArticleTitle(
  prev: ArticleTitleState,
  key: string,
  title: string | null,
): ArticleTitleState {
  if (title) return { key, title };
  return prev?.key === key ? null : prev;
}

export function visibleArticleTitle(state: ArticleTitleState, routeKey: string): string | null {
  return state && state.key === routeKey ? state.title : null;
}
